import React, { useContext, useState } from "react";
import { Input, TextAreaInput } from "../../Helpers/Input/Input";
import OffcanvasFooter from "../../Helpers/Offcanvasfooter/OffcanvasFooter";
import { useFormik } from "formik";
import {
  useCreateCategoryMutation,
  useEditCategoryMutation,
} from "../../../Redux/service/InventorySetup/InventorySetup";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { popupcontext } from "../../../context/Popupscontext";
import UpdatePic from "../../Helpers/UploadPic/UpdatePic";
import trans from "../../../utils";

const CategoryFormBody = ({ refetch, data, isEditing, onClose }) => {
  const [createCategory] = useCreateCategoryMutation();
  let [editCategory] = useEditCategoryMutation();
  let { handleClose } = useContext(popupcontext);
  const [picUpdated, setPicUpdated] = useState(false);

  let validSchema = Yup.object({
    name: Yup.string()
      .required("Name is required")
      .test(
        "not-empty-after-trim",
        "Name cannot be empty or only spaces",
        (value) => value && value.trim().length > 0
      )
      .matches(
        /^[^&"'/<>%_+{}[\];$]*$/,
        "Name can't contain & \" ' / < > % _ + { } [ ] ; $"
      )
      .min(2)
      .max(40),
    description: Yup.string().optional().max(256),
  });
  const addData = useFormik({
    initialValues: {
      name: data?.name || "",
      description: data?.description || "",
      picture: data?.picture || null,
    },
    validationSchema: validSchema,
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("description", values.description);

      // Ensure picture is a file and append it
      if (values.picture && picUpdated) {
        formData.append("picture", values.picture);
      } else if (values.picture && !picUpdated) {
      } else {
        formData.append("picture", "");
      }
      if (isEditing) {
        try {
          const response = await editCategory({ id: data.id, data: formData });
          if (response.error) {
            const errorMsg =
              response.error.data?.errors?.[0]?.msg ||
              "Failed to edit category.";
            return toast.error(errorMsg);
          }
          refetch();
          toast.success("Category edited successfully");
          onClose();
        } catch (error) {
          toast.error(trans("Error editing form:"), error);
        }
      } else {
        try {
          const response = await createCategory(formData);
          if (response.error) {
            const errorMsg =
              response.error.data?.errors?.[0]?.msg ||
              "Failed to add category.";
            return toast.error(errorMsg);
          }
          toast.success("Category added successfully");
          refetch();
          handleClose("form");
        } catch (error) {
          toast.error("Error submitting form:", error);
        }
      }
    },
  });

  const handlePictureSelect = (file) => {
    addData.setFieldValue("picture", file); // Update Formik's picture field
  };
  return (
    <>
      <form onSubmit={addData.handleSubmit}>
        <UpdatePic
          onPictureSelect={handlePictureSelect}
          picture={data?.picture}
          setPicUpdated={setPicUpdated}
        />
        <div className="userinfo mb-24">
          <Input
            title="Category name"
            type="text"
            placeholder="Ex. Volvo"
            formstyle="user-form w-100"
            id="name"
            name="name"
            onBlur={addData.handleBlur}
            onChange={addData.handleChange}
            errors={addData.errors.name}
            touched={addData.touched.name}
            value={addData.values.name || ""}
          />
          <TextAreaInput
            title="Description"
            placeholder="Description about the category"
            name="description"
            id="description"
            formstyle="user-form w-100"
            onBlur={addData.handleBlur}
            onChange={addData.handleChange}
            errors={addData.errors.description}
            touched={addData.touched.description}
            value={addData.values.description || ""}
          />
        </div>
        <OffcanvasFooter addData={addData} onClose={onClose} />
      </form>
    </>
  );
};

export default CategoryFormBody;
